export default "__VITE_ASSET__PQRRwFgj__"